module.exports = __webpack_public_path__ + "img/3.5ab7790e.jpg";